import { normalizeUri, max, get } from '../../../utils/utils';
import { ItemKind } from '../../../constants/ItemKind';
import { MediaType } from '../../../constants/MediaType';
function findThumbnailUrl(images) {
  const big = max(images, function (image) {
    return image.width + image.height;
  });
  return big.src;
}
export function toItem(data) {
  return {
    id: data.deviationid,
    name: data.title || '',
    kind: ItemKind.File,
    source: 'deviantArt',
    mediaType: MediaType.Picture,
    thumbnailUrl: normalizeUri(findThumbnailUrl(data.thumbs)),
    createdAt: data.published_time,
    previewUrl: normalizeUri(get(data, 'preview.src', '')),
    fileUrl: normalizeUri(get(data, 'content.src', '')),
    width: get(data, 'content.width', null),
    height: get(data, 'content.height', null),
    tags: []
  };
}